import type { RouteObject } from 'react-router';

import * as cmsViewFileHorizonRouteExports from '#/modules/cms/files/pages/view/CmsViewFile.horizon-route';
import { horizonRouteToObject } from '#/routing/utils/horizonRouteToObject';

import { cmsViewFileRoute } from './cmsFiles.routes';

export const cmsFilesRouteObjects = [
  {
    path: cmsViewFileRoute.fullPath,
    ...horizonRouteToObject(cmsViewFileHorizonRouteExports),
  },
] satisfies RouteObject[];
